import React, { useState } from "react";
import { Table, Button, Icon } from "semantic-ui-react";
import { map } from "lodash";
import moment from "moment";
import { ModalBasic } from "../../../Common";
import { PaymentProductList } from "../../../Admin";
import { getTableLabel } from "../../../../utils/table";
import { getPaymentMethod, describePaymentParts } from "../../../../utils/constants";
import "./TablePayments.scss";

export function TablePayments(props) {
  // onVoid (opcional): muestra "Anular" en cada venta cobrada — solo lo pasa
  // Historial de Pagos y solo para Admin/Súper Usuario.
  const { payments, detailed, onVoid } = props;
  const [showModal, setShowModal] = useState(false);
  const [titleModal, setTitleModal] = useState(null);
  const [contentModal, setContentModal] = useState(null);


  const openCloseModal = () => setShowModal((prev) => !prev);

  const showDetails = (payment) => {
    setTitleModal(`Pedidos de la mesa ${getTableLabel(payment)}`);
    setContentModal(<PaymentProductList payment={payment} />);
    openCloseModal();
  };

  return (
    <>
      <Table className="table-payments-admin">
        <Table.Header className="screen-only">
          <Table.Row>
            <Table.HeaderCell>Mesa</Table.HeaderCell>
            <Table.HeaderCell>Total</Table.HeaderCell>
            <Table.HeaderCell>Tipo de pago</Table.HeaderCell>
            <Table.HeaderCell>Fecha</Table.HeaderCell>
            <Table.HeaderCell className="screen-only"></Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {map(payments, (payment, index) => (
            <React.Fragment key={index}>
              <Table.Row>
                <Table.Cell>{getTableLabel(payment)}</Table.Cell>
                <Table.Cell>
                  S/ {payment.totalPayment}
                  {Number(payment.discount_amount) > 0 && (
                    <div
                      className="table-payments-admin__discount"
                      title={payment.discount_reason}
                    >
                      Desc. − S/ {payment.discount_amount}
                    </div>
                  )}
                </Table.Cell>
                <Table.Cell>
                  <Icon name={getPaymentMethod(payment.paymentType)?.icon} />
                  {getPaymentMethod(payment.paymentType)?.text}
                  {payment.operation_code && (
                    <span className="table-payments-admin__op">
                      {" "}· Op. {payment.operation_code}
                    </span>
                  )}
                  {payment.paymentType === "MIXED" && (
                    <div className="table-payments-admin__op">
                      {describePaymentParts(payment.parts)}
                    </div>
                  )}
                </Table.Cell>
                <Table.Cell>
                  {moment.parseZone(payment.created_at).format("DD/MM/YYYY - HH:mm")}
                </Table.Cell>
                <Table.Cell textAlign="right" className="screen-only table-payments-admin__actions">
                  <Button icon onClick={() => showDetails(payment)} title="Ver detalle">
                    <Icon name="eye" />
                  </Button>
                  {onVoid && payment.paymentType !== "LOSS" && (
                    <Button
                      icon
                      basic
                      color="red"
                      onClick={() => onVoid(payment)}
                      title="Anular venta (solo Admin): para un cobro duplicado, un error en el monto o la forma de pago, o una devolución. La venta no se borra: deja de contar en ventas, reportes y caja, y queda en Reportes → Anulaciones y descuentos."
                    >
                      <Icon name="ban" />
                    </Button>
                  )}
                </Table.Cell>
              </Table.Row>

              {detailed && (
                <Table.Row className="table-payments-admin__detail-row">
                  <Table.Cell colSpan={5}>
                    <div className="table-payments-admin__detail-indent">
                      <PaymentProductList payment={payment} showImage={false} />
                    </div>
                  </Table.Cell>
                </Table.Row>
              )}
            </React.Fragment>
          ))}
        </Table.Body>
      </Table>

      <ModalBasic
        show={showModal}
        onClose={openCloseModal}
        title={titleModal}
        children={contentModal}
      />
    </>
  );
}

// Cabecera de columnas para impresión, pensada para pasarse como `children`
// de <PrintHeader> — así queda en el <thead> de <PrintTable>, que el
// navegador repite en cada página (ver PrintTable.js/PrintHeader.scss).
// El <thead> real de la tabla de arriba se oculta en impresión (screen-only)
// porque, anidado en el cuerpo del reporte, no se repite por su cuenta.
export function TablePaymentsPrintColumns() {
  return (
    <div className="print-header-admin__columns">
      <span>Mesa</span>
      <span>Total</span>
      <span>Tipo de pago</span>
      <span>Fecha</span>
    </div>
  );
}
